import { WordsType } from '../keys';

const wordsKeys: WordsType = {
  accept: 'Accept',
  accordingTo: 'according to',
  account: 'Account',
  accountManager: 'Account manager',
  active: 'Active',
  activity: 'Activity',
  actions: 'Actions',
  add: 'Add',
  addDescription: 'Add description',
  addMessage: 'Add message',
  addTag: 'Add tag',
  addItem: 'Add item',
  addMore: 'Add more',
  addReaction: 'Add reaction',
  addService: 'Add service',
  addToFavorites: 'Add to favorites',
  addUser: 'Add user',
  addYourCommentOptional: 'Add your comment (optional)',
  adorable: 'Adorable',
  all: 'All',
  allActivity: 'All activity',
  allAttachments: 'All attachments',
  attachments: 'Attachments',
  attachFile: 'Attach file',
  allocate: 'Allocate',
  allocateFunds: 'Allocate funds',
  allPages: 'All pages',
  allStatuses: 'All statuses',
  allTime: 'All time',
  allUsers: 'All users',
  already_selected: 'Already selected',
  amount: 'Amount',
  amountDue: 'Amount due',
  and: 'and',
  andUpperCase: 'AND',
  orUpperCase: 'OR',
  any: 'Any',
  anyType: 'Any type',
  api: 'API',
  applicationLanguage: 'Application language',
  apply: 'Apply',
  approve: 'Approve',
  appliedEvents: 'Applied events',
  artists: 'Artists',
  archivizerTeam: 'Archivizer team',
  as: 'as',
  assignAsCreator: 'Assign as creator',
  assignAsOwner: 'Assign as owner',
  attach: 'Attach',
  attachImage: 'Attach image',
  aud: 'AUD',
  auto: 'Auto',
  autoAllocate: 'Auto allocate',
  author: 'Author',
  aws: 'AWS',
  back: 'Back',
  backToProject: 'Back to project',
  backtrace: 'Backtrace',
  badDebt: 'Bad debt',
  dataPrivacyPolicy: 'Data Privacy Policy',
  block: 'Block',
  blocked: 'Blocked',
  brand: 'Brand',
  brief: 'Brief',
  browse: 'Browse',
  budget: 'Budget',
  by: 'by',
  cad: 'CAD',
  cancel: 'Cancel',
  canceled: 'Canceled',
  caution: 'Caution!',
  celebrate: 'Celebrate',
  change: 'Change',
  changeCurrency: 'Change currency',
  changeOwner: 'Change owner',
  changeUnits: 'Change units',
  clap: 'Clap',
  clear: 'Clear',
  clearAll: 'Clear all',
  clearFilter: 'Clear filter',
  clearFilters: 'Clear filters',
  clearSelection: 'Clear selection',
  clickToCopy: 'Click to copy',
  client: 'Client',
  clientDebt: 'Client debt',
  clientManager: 'Client manager',
  clients: 'Clients',
  close: 'Close',
  colors: 'Colors',
  colorScheme: 'Color scheme',
  colorSchemeDark: 'Dark',
  colorSchemeLight: 'Light',
  comment: 'Comment',
  company: 'Company',
  companyCustomTabs: 'Company custom tabs',
  companyTabs: 'Company Tabs',
  conditions: 'conditions',
  confirm: 'Confirm',
  contactInfo: 'Contact info',
  contactSupport: 'Contact support',
  continue: 'Continue',
  control: 'Control',
  copy: 'Copy',
  copyName: 'Copy name',
  copyGroupLink: 'Copy group link',
  copyGroupName: 'Copy group name',
  copyId: 'Copy ID',
  copyLink: 'Copy link',
  copyProjectLink: 'Copy project link',
  copyProjectName: 'Copy project name',
  copyTaskLink: 'Copy task link',
  copyTaskName: 'Copy task name',
  copyUuid: 'Copy UUID',
  cost: 'Cost',
  coefficient: 'K',
  create: 'Create',
  createCustomTab: 'Create custom tab',
  createdBy: 'Created by',
  createNewFilter: 'Create new filter',
  createView: 'Create view',
  criticalRequirements: 'Critical requirements',
  current: 'Current',
  custom: 'Custom',
  customTabs: 'Custom tabs',
  date: 'Date',
  dateAndTimeFormat: 'Date and time format',
  dateOfBirth: 'Date of birth',
  day: 'Day',
  debt: 'Debt',
  default: 'Default',
  delete: 'Delete',
  deleteView: 'Delete view',
  delete_filter: 'Delete filter',
  deleting: 'Deleting...',
  deselect: 'Deselect',
  deselectLowerCase: 'deselect',
  denyAccess: 'Deny access',
  description: 'Description',
  descriptionOptional: 'Description (optional)',
  digitalOcean: 'Digital Ocean',
  disable: 'Disable',
  dislike: 'Dislike',
  dontCloseOrRefresh: 'Don’t close or refresh.',
  download: 'Download',
  downloading: 'Downloading',
  downloadAll: 'Download all',
  downloadAllUpperCase: 'DOWNLOAD ALL',
  downloadTaskResult: 'Download task result',
  dpi: 'dpi',
  draft: 'Draft',
  draftBudget: 'Draft budget',
  drawings: 'Drawings',
  dueDate: 'Due date',
  duplicate: 'Duplicate',
  edit: 'Edit',
  editCustomTab: 'Edit custom tab',
  editView: 'Edit View',
  elasticSearch: 'Elastic search',
  emailAddress: 'Email address',
  emailChanged: 'Email changed',
  enable: 'Enable',
  endUserLicenseAgreementAndTermsOfService:
    'End User License Agreement and Terms of Service',
  english: 'English',
  enterMessageId: 'Enter message ID',
  enterMessageIds: 'Enter message IDs',
  error: 'Error',
  errorMessage: 'Error message',
  estimate: 'Estimate',
  eur: 'EUR',
  existingField: 'Existing field',
  expand_view: 'Expand view',
  expenses: 'Expenses',
  export: 'Export',
  extract: 'Extract',
  extracting: 'Extracting..',
  favorite: 'Favorite',
  favorites: 'Favorites',
  field: 'Field',
  fileDownloadStarted: 'File download started',
  files: 'Files',
  filter: 'Filter',
  filterFavorite: 'Filter favorite',
  filters: 'Filters',
  fin: 'Fin',
  finance: 'Finance',
  final: 'Final',
  fire: 'Fire',
  featured: 'Featured',
  flagged: 'Flagged',
  for: 'for',
  forward: 'Forward',
  from: 'From',
  fullyPaid: 'Fully paid',
  gbp: 'GBP',
  gpt: 'GPT',
  general: 'General',
  generate: 'Generate',
  globalCustom: 'Global custom',
  goBack: 'Go back',
  groupBy: 'Group by',
  gridView: 'Grid view',
  help: 'Help',
  helpCenter: 'Help Center',
  hidden: 'Hidden',
  hiddenLowerCase: 'hidden',
  hide: 'Hide',
  hideDimensions: 'Hide dimensions',
  hideRuler: 'Hide ruler',
  hideList: 'Hide list',
  high: 'High',
  home: 'Home',
  homepage: 'Go to the home page',
  images: 'Images',
  imageScale: 'Image scale',
  import: 'Import',
  in: 'in',
  include: 'Include',
  included: 'Included',
  incomeStatement: 'Income statement',
  info: 'Info',
  invisibleForClient: 'Invisible for client',
  invisibleForWorker: 'Invisible for worker',
  invisible: 'Invisible',
  invite_user: 'Invite user',
  inFavorites: 'In favorites',
  input: 'INPUT',
  itc: 'ITC',
  its: "It's",
  itemsList: 'Items list',
  issues: 'Issues',
  joined: 'Joined',
  languagesSpoken: 'Languages spoken',
  lastMessage: 'Last message',
  lastMonth: 'Last month',
  lastWeek: 'Last week',
  lastYear: 'Last year',
  lastSixDays: 'Last 6 days',
  lastSixWeeks: 'Last 6 weeks',
  lastSixMonths: 'Last 6 months',
  lastSixQuarters: 'Last 6 quarters',
  lastSixYears: 'Last 6 years',
  latest: 'Latest',
  laughing: 'Laughing',
  ld: 'LD',
  learnMore: 'Learn more',
  leave: 'Leave',
  leaveMessage: 'Leave Message',
  lessMonth: '< 1 month',
  lessTwoMonth: '< 2 months',
  lessTwoWeek: '< 2 weeks',
  lessWeek: '< 1 week',
  letters: { h: 'h', m: 'm' },
  license: 'License',
  like: 'Like',
  link: 'Link',
  linkCopied: 'Link copied',
  listView: 'List view',
  loadMore: 'Load More',
  loadingMore: 'Loading more...',
  loa: 'LOA',
  loaUntil: 'LOA until',
  location: 'Location',
  log_out: 'Log out',
  login_page: 'Go to the login page',
  love: 'Love',
  low: 'Low',
  mad: 'Mad',
  makeInvisible: 'Make invisible',
  makeVisible: 'Make visible',
  makeDefault: 'Make default',
  media: 'Media',
  members: 'Members',
  membersGenitiveLowerCase: 'members',
  mergeSimilar: 'Merge similar',
  mixed: 'Mixed',
  model: 'Model',
  modelWithExtensions: 'Model (.rar, .zip)',
  month: 'Month',
  more: 'More',
  moreTwoMonth: '> 2 months',
  mostLiked: 'Most liked',
  mostUsed: 'Most used',
  move: 'Move',
  myLibrary: 'My library',
  myCompanyFavorites: 'My company favorites',
  companyFavorite: 'Company favorite',
  companyFavorites: 'Company favorites',
  multiline: 'Multiline',
  muteNotifications: 'Mute notifications',
  mute: 'Mute',
  na: 'n/a',
  name: 'Name',
  nameEn: 'Name (En)',
  nameCopied: 'Name copied',
  nda: 'NDA',
  ndaFile: 'NDA file',
  needHelp: 'Need help?',
  next: 'Next',
  new: 'New',
  newest: 'Newest',
  newField: 'New field',
  newVersionAvailable: 'New version available!',
  net: 'Net',
  no: 'No',
  noGrouping: 'No grouping',
  noResultsYet: 'No results yet',
  noSearchResults: 'No search results',
  notAsked: 'Not asked',
  notification: 'Notification',
  notificationsEnabled: 'Notifications enabled',
  of: 'of',
  ok: 'Ok',
  on: 'on',
  onboardingTour: 'Onboarding tour',
  oneDay: '1 day',
  oneMonth: '1 month',
  oneWeek: '1 week',
  open_in_new_tab: 'Open in new tab',
  open: 'Open',
  openOptions: 'Open options',
  or: 'Or',
  orLowerCase: 'or',
  overdue: 'Overdue',
  output: 'OUTPUT',
  owner: 'Owner',
  paid: 'Paid',
  passwordChanged: 'Password changed',
  pay: 'Pay',
  payByCard: 'Pay by card',
  payOnline: 'Pay online',
  payer: 'Payer',
  paste: 'Paste',
  paymentMethod: 'Payment Method',
  payments: 'Payments',
  pause: 'Pause',
  pastPayments: 'Past payments',
  paymentTerms: 'Payment Terms',
  paymentTermsAndRefundPolicy: 'Payment terms and refund policy',
  pendingPayments: 'Pending payments',
  phoneNumber: 'Phone number',
  pinned: 'Pinned',
  play: 'Play',
  planned: 'Planned',
  platformTerms: 'Platform terms',
  pleaseDontCloseOrRefreshThePageUntilItsDoneDoingSoWillStopTheDownload:
    'Please don’t close or refresh the page until it’s done — doing so will stop the download.',
  policies: 'Policies',
  postMessage: 'Post message',
  premiumContent: 'Premium content',
  previewModel: 'Preview model',
  previewModelWithExtensions: 'Preview model (.glb)',
  price: 'Price',
  privacy: 'Privacy',
  privacyPolicy: 'Privacy policy',
  proceed: 'Proceed',
  processing: 'Processing...',
  profile: 'Profile',
  proforma: 'Proforma',
  proformaOld: 'Proforma old',
  progress: 'Progress',
  publish: 'Publish',
  published: 'Published',
  px: 'px',
  quantity: 'Quantity',
  receipt: 'Receipt',
  receiveNotifications: 'Receive notifications',
  receiver: 'Receiver',
  recentlySelected: 'Recently selected',
  references: 'References',
  refineSearch: 'Refine search',
  refund: 'Refund',
  refunds: 'Refunds',
  refresh: 'Refresh',
  remove: 'Remove',
  removeAll: 'Remove all',
  removeFromFavorites: 'Remove from favorites',
  rename: 'Rename',
  requirements: 'Requirements',
  reset_password: 'Reset password',
  required: 'Required',
  reset: 'Reset',
  resetFilters: 'Reset filters',
  resolve: 'Resolve',
  resolved: 'Resolved',
  restore: 'Restore',
  results: 'results',
  resultsFor: 'Results for',
  rub: 'RUB',
  russian: 'Russian',
  sad: 'Sad',
  save: 'Save',
  saveACopy: 'Save a copy',
  saveChanges: 'Save Changes',
  saved: 'Saved',
  savedFilters: 'Saved filters',
  saveFilter: 'Save filter',
  saveToFavorites: 'Save to favorites',
  scopeOfWork: 'Scope of work',
  score: 'Score',
  search_user_by_name: 'Search user by name',
  search: 'Search',
  searching: 'Searching...',
  searchResults: 'Search results',
  searchByCompanyName: 'Search by company name',
  searchByName: 'Search by name',
  secondsGenitive: 'seconds',
  select: 'Select',
  selectAll: 'Select all',
  selected: 'Selected',
  selectedLowerCase: 'selected',
  selectToAddToTheProject: 'Select to add to the project',
  send: 'Send',
  sendTo: 'Send to',
  sentTo: 'Sent to',
  sender: 'Sender',
  sendInstructions: 'Send instructions',
  sendToAllTasks: 'Send to all tasks',
  sendToEmail: 'Send to email',
  sendViaEmail: 'Send via email',
  sent: 'Sent',
  serviceAgreement: 'Service agreement',
  serviceName: 'Service name',
  set: 'Set',
  setAllVisible: 'Set all visible',
  setAllHidden: 'Set all hidden',
  setCustomDate: 'Set custom date',
  setDueDate: 'Set due date',
  settings: 'Settings',
  show_n_selected_items: {
    show: 'Show',
    hide: 'Hide',
    selected_items: 'selected items'
  },
  show: 'Show',
  showAll: 'Show all',
  showDimensions: 'Show dimensions',
  showRuler: 'Show ruler',
  showFavoriteOnly: 'Show favorite only',
  showFavoritesOfMyCompany: 'Show favorites of my company',
  showing: 'Showing',
  showLess: 'Show less',
  showList: 'Show list',
  showMore: 'Show more',
  showMyLibrary: 'Show my library',
  showTotals: 'Show totals',
  sign_out: 'Sign out',
  size: 'Size',
  sketches: 'Sketches',
  skip: 'Skip',
  skipStep: 'Skip step',
  sku: 'SKU',
  smartContract: 'Smart contract',
  sortAZ: 'Sort A-Z',
  sortZA: 'Sort Z-A',
  sortBy: 'Sort by',
  sortByMostLiked: 'Sort by: Most liked',
  sortByMostUsed: 'Sort by: Most used',
  sortByNewest: 'Sort by: Newest',
  sortByFeatured: 'Sort by: Featured',
  starred: 'Starred',
  startDate: 'Start date',
  state: 'State',
  status: 'Status',
  statusColon: 'Status:',
  renderer: 'Renderer',
  style: 'Style',
  tableView: 'Table view',
  start: 'Start',
  stop: 'Stop',
  stopAll: 'Stop all',
  studio: 'Studio',
  submit: 'Submit',
  subscribed: 'Subscribed',
  subscribeAgain: 'Subscribe again',
  success: 'Success',
  surnameEn: 'Surname (En)',
  surprised: 'Surprised',
  system: 'System',
  tagName: 'Tag name',
  task: 'Task',
  tax: 'Tax',
  tbd: 'TBD',
  terms: 'Terms',
  termsOfService: 'Terms of Service',
  terrified: 'Terrified',
  testProjectInfo: 'Test project info',
  textHere: 'Text here',
  textures: 'Textures',
  tfe: 'TFE',
  thereAreNoMatchesForSelectedFilters:
    'There are no matches for selected filters',
  threeDs: '3Ds',
  threeDStock: '3D Stock',
  thisMonth: 'This month',
  time: 'Time',
  timer: {
    days: 'days',
    hours: 'hours',
    minutes: 'minutes',
    seconds: 'seconds'
  },
  times: 'Times',
  timeZone: 'Time zone',
  to: 'To',
  today: 'Today',
  toFavorites: 'To favorites',
  total: 'Total',
  totalDebt: 'Total debt',
  toggleView: 'Toggle view',
  trackedTime: 'Tracked time',
  tryAgain: 'Try again',
  uah: 'UAH',
  ukraine: 'Ukrainian',
  unblock: 'Unblock',
  underpayment: 'Underpayment',
  unit: 'Unit',
  units: {
    cm: 'cm',
    in: 'in'
  },
  untagged: 'Untagged',
  ungrouped: 'Ungrouped',
  until: 'Until',
  unfavorite: 'Unfavorite',
  unstarred: 'Unstarred',
  unsubscribed: 'Unsubscribed',
  unsubscribe: 'Unsubscribe',
  unselectAllItems: 'Unselect all items',
  undefined: 'Undefined',
  unmute: 'Unmute',
  unmuteAgain: 'Unmute again',
  update: 'Update',
  updated: 'Updated',
  updateExistingFilter: 'Update existing filter',
  updateImageVersions: 'Update image versions',
  updateNow: 'Update now',
  upload: 'Upload',
  uploaded: 'Uploaded',
  usd: 'USD',
  used: 'Used',
  user: 'User',
  useDefaultView: 'Use default view',
  vat: 'VAT',
  view: 'View',
  view3DModel: 'View 3D model',
  viewAccounts: 'View accounts',
  viewAll: 'View all',
  viewAllMembers: 'View all members',
  viewCR: 'View CR',
  viewProfile: 'View Profile',
  visibility: 'Visibility',
  visibilityForClient: 'Visibility for client',
  visibilityForWorker: 'Visibility for worker',
  visible: 'Visible',
  visibleForClient: 'Visible for client',
  void: 'Void',
  week: 'Week',
  welcomeToArchivizer: 'Welcome to ARCHIVIZER!',
  whiteboard: 'Whiteboard',
  withdraw: 'Withdraw',
  workers: 'Workers',
  watchGuide: 'Watch guide',
  workflowGuide: 'Workflow guide',
  writeHere: 'Write here',
  whiteboardNotifications: 'Whiteboard notifications',
  yes: 'Yes',
  yesterday: 'Yesterday',
  inherit: 'Inherit',
  star: 'Star',
  flag: 'Flag',
  notify: 'Notify'
};

export default wordsKeys;
